import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setShowJobPaymentPopup} from "../../../actions/A_Popups";
import JobPaymentPopupBilling from "./JobPaymentPopupBilling";
import JobPaymentPopupPaymentSelections from "./JobPaymentPopupPaymentSelections";
import MaterialsIcons from "../../Icons/MaterialsIcons";
import JobPaymentPopupFooterButtons from "./JobPaymentPopupFooterButtons";
import JobPaymentPopupAdjust from "./JobPaymentPopupAdjust";
import {PAYMENT_STEPS} from "./jobPaymentReducer";
import JobPaymentPopupFinal from "./JobPaymentPopupFinal";
import JobPaymentPopupTransactions from "./JobPaymentPopupTransactions";
import JobPaymentPopupHeader from "./JobPaymentPopupHeader";


const JobPaymentPopup = (props) => {

  const {setShowJobPaymentPopup, paymentStep} = props;

  const closePopup = () => {
    setShowJobPaymentPopup(false);
  };

  return (
    <div className="ui-popup ui-popup--payment">
      <div className="job-payment flex">
        <div className="job-payment__left">
          <div className="job-payment__left-image"/>
          <div className="job-payment__box">
            <div className="job-payment__box-icon">
              {MaterialsIcons.CartFilledIcon}
            </div>
            <p className="job-payment__box-title">
              <FormattedMessage id="paymentPopup.checkout"/>
            </p>
            <p className="job-payment__box-sub-title">
              <FormattedMessage id="paymentPopup.checkoutSubTitle"/>
            </p>
          </div>
        </div>
        <div className="job-payment__right">
          <JobPaymentPopupHeader closePopup={closePopup}/>
          {paymentStep === PAYMENT_STEPS.billing ? <JobPaymentPopupBilling/> : null}
          {paymentStep === PAYMENT_STEPS.payments ? <JobPaymentPopupPaymentSelections/> : null}
          {paymentStep === PAYMENT_STEPS.adjustPrice ? <JobPaymentPopupAdjust/> : null}
          {paymentStep === PAYMENT_STEPS.finalPage ? <JobPaymentPopupFinal/> : null}
          {paymentStep === PAYMENT_STEPS.transactions ? <JobPaymentPopupTransactions/> : null}
          <JobPaymentPopupFooterButtons closePopup={closePopup}/>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {showJobPaymentPopup} = store.popups;
  const {paymentStep} = store.jobPaymentState;

  return {
    showJobPaymentPopup,
    paymentStep,
  };
};

const mapDispatchToProps = {
  setShowJobPaymentPopup,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopup)
)
